import React from 'react'
import PrivacyPolicy from '../containers/PrivacyPolicy/PrivacyPolicyNew'
import Seo from '../common/Components/Seo/Seo'
import PrivacyPolicySchema from '../common/Components/StructuredData/PrivacyPolicySchema'

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Seo
        seo={{
          title: "Privacy Policy | Airport Parking Deals Data Protection",
          description: "Learn how Airport Parking Deals protects your personal information and data privacy when you book airport parking through our platform. GDPR compliant and secure.",
          keywords: "privacy policy, data protection, personal information, secure booking, GDPR compliance, data security, airport parking privacy"
        }} />
      <PrivacyPolicySchema />
      <div className="w-full bg-[#0C735F] h-28 md:h-[180px]"></div>

      <PrivacyPolicy />
    </div>
  )
}

export default PrivacyPolicyPage
